var exports = {
  "Wf": "xaf9ae18d--02474c--small-pin",
  "YE": "xaf9ae18d--02474c--large-pin",
  "Kk": "xaf9ae18d--02474c--icon",
};

module.exports = exports;
